import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { full_name: "Prénom Nom", role: "Fonction", desc: "" } },
  { id: "fallback-2", props: { full_name: "Prénom Nom", role: "Fonction", desc: "" } },
  { id: "fallback-3", props: { full_name: "Prénom Nom", role: "Fonction", desc: "" } },
];

const DEFAULTS = { eyebrow: "", heading: "L'équipe", subheading: "", anchor_id: "" };

export default function TeamSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  // Le nom porte la fiche : sans lui, il n'y a personne à présenter.
  const members = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.full_name);
  if (!members.length) return null;

  return (
    <section id={t.anchor_id || undefined} className="max-w-[1240px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className="text-center">
        {t.eyebrow && (
          <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
        )}
        <RichText
          as="h2"
          className="font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[16px] text-graphite mt-4" html={t.subheading} />}
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {members.map((block) => (
          <div key={block.id} data-block-key={block.id} className="text-center">
            {block.props.image_url ? (
              <img
                src={block.props.image_url}
                alt=""
                loading="lazy"
                className="mx-auto h-28 w-28 rounded-full object-cover"
              />
            ) : (
              // Pastille d'initiale plutôt qu'un cadre vide : une équipe sans
              // photos reste présentable, ce qui est le cas le plus fréquent
              // au moment où le thème vient d'être généré.
              <span className="mx-auto flex h-28 w-28 items-center justify-center rounded-full bg-sand font-display text-[28px] text-ink">
                {String(block.props.full_name).trim().charAt(0).toUpperCase()}
              </span>
            )}
            <p className="mt-4 text-[15px] font-semibold text-ink">{block.props.full_name}</p>
            {block.props.role && <p className="text-[13px] text-gold">{block.props.role}</p>}
            {block.props.desc && <p className="mt-2 text-[13px] leading-relaxed text-graphite">{block.props.desc}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
